// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"trial-confirmation-modal_confirmation-modal__85iC3","confirmation-modal__text":"trial-confirmation-modal_confirmation-modal__text__CFYWe"};